// ** UI
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

// ** Components
import Section from '@/components/common/Section';
import ComponentElementsPersonCard from '@/components/strapi/Elements/ComponentElementsPersonCard';

// ** Type
import type { StrapiComponentProps } from '@/types/strapi';
import type { ComponentBlocksSectionBlock as BlocksSectionBlock } from '@/types/graphql';

type ComponentBlocksSectionBlockProps = StrapiComponentProps<BlocksSectionBlock>;

// ! Deprecated - Person Block
const ComponentBlocksSectionBlock = ({
	host,
	containerSx,
	sectionTitle,
	personBlockContent
}: ComponentBlocksSectionBlockProps) => {
	return (
		<Section containerSx={containerSx}>
			{sectionTitle && (
				<Typography
					variant="title-lg"
					component="h2"
					sx={{
						mb: 10,
						color: 'common.black',
						fontSize: { xs: '2rem', md: '2.5rem' },
						lineHeight: { xs: '2.5rem', md: '3rem' },
						letterSpacing: { xs: '-0.64px', md: '-1.2px' }
					}}
				>
					{sectionTitle}
				</Typography>
			)}

			<Grid
				container
				spacing={8}
				sx={() => ({
					margin: 0,
					maxWidth: '100%'
					// background: background
					// 	? `linear-gradient(to right, ${palette.primary.light} 0%, ${palette.primary.lighter} 100%)`
					// 	: undefined
				})}
			>
				{personBlockContent.map((item) => {
					if (!item) return null;
					return (
						<Grid key={item?.individual?.documentId} size={{ xs: 12, sm: 6, lg: 4 }}>
							<ComponentElementsPersonCard host={host} {...item} />
						</Grid>
					);
				})}
			</Grid>
		</Section>
	);
};

export default ComponentBlocksSectionBlock;
